import { Data } from "effect";
export class StripeSubscriptionUnavailableError extends Data.TaggedError("@open-revenue/schema/stripe/StripeSubscriptionUnavailableError") {
    constructor(message){
        super({
            message
        });
    }
}
export class StripeEventIgnored extends Data.TaggedError("@open-revenue/schema/stripe/StripeEventIgnored") {
    constructor(reasonOrType){
        super();
        this.reason = typeof reasonOrType === "string" ? reasonOrType : `Stripe event type ${reasonOrType} ignored`;
    }
    reason;
}
export class StripeCustomerDeleted extends Data.TaggedError("@open-revenue/schema/stripe/StripeCustomerDeleted") {
    customerId;
    constructor(customerId){
        super(), this.customerId = customerId;
    }
}
export class StripeEventSerializationError extends Data.TaggedError("@open-revenue/schema/stripe/StripeEventSerializationError") {
    stripeMessage;
    constructor(stripeMessage){
        super(), this.stripeMessage = stripeMessage;
    }
}
export class NoStripeSubscriptionForInvoice extends Data.TaggedError("@open-revenue/schema/stripe/NoStripeSubscriptionForInvoice") {
    invoiceId;
    constructor(invoiceId){
        super(), this.invoiceId = invoiceId;
    }
}
export class NoStripeInvoiceForCharge extends Data.TaggedError("@open-revenue/schema/stripe/NoStripeInvoiceForCharge") {
    chargeId;
    constructor(chargeId){
        super(), this.chargeId = chargeId;
    }
}
export class NoItemsInSubscription extends Data.TaggedError("@open-revenue/schema/stripe/NoItemsInSubscription") {
    subscriptionId;
    constructor(subscriptionId){
        super(), this.subscriptionId = subscriptionId;
    }
}
